import {MyMahiAPI} from "../api/MyMahiAPI";
import {MyMahiStatusType} from "../domain/verification/MyMahiStatusType";

export class MyMahiService {
    private static instance: MyMahiService;
    private myMahiAPI: MyMahiAPI

    private constructor() {
        this.myMahiAPI = new MyMahiAPI();
    }

    async requestVerification(verificationId: string): Promise<string> {
        return await this.myMahiAPI.requestMyMahiVerification(verificationId)
    }

    async retrieveVerificationStatus(verificationId: string): Promise<MyMahiStatusType> {
        return await this.myMahiAPI.retrieveMyMahiVerificationStatus(verificationId)
    }

    async retrieveVerificationUrl(verificationId: string): Promise<string> {
        return await this.myMahiAPI.retrieveMyMahiVerificationUrl(verificationId)
    }

    async cancelVerification(verificationId: string): Promise<void> {
        await this.myMahiAPI.cancelMyMahiVerification(verificationId)
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new MyMahiService();
        }
        return this.instance;
    }
}